import React from 'react';
import styles from './AutomationFooter.module.css';

export interface AutomationLink {
  label: string;
  url: string | null;
}

interface AutomationFooterProps {
  title?: string;
  links: AutomationLink[];
  /** Optional click handler for usage metrics logging */
  onLinkClick?: (label: string, url: string) => void;
}

/**
 * AutomationFooter - Displays automation links at the bottom of DataGrids
 */
const AutomationFooter: React.FC<AutomationFooterProps> = ({
  title = "For Optimal Shelf Quantity Automation:",
  links,
  onLinkClick,
}) => {
  if (!links || links.length === 0) {
    return null;
  }

  // Filter out links with null URLs
  const validLinks = links.filter(
    (link): link is AutomationLink & { url: string } => link.url !== null,
  );

  if (validLinks.length === 0) {
    return null;
  }

  return (
    <div className={styles.automationFooter}>
      <strong>{title}</strong>
      <br />
      {validLinks.map((link, index) => (
        <React.Fragment key={index}>
          <a
            href={link.url}
            target="_blank"
            rel="noreferrer"
            onClick={() => onLinkClick?.(link.label, link.url)}>
            {link.label}
          </a>
          {index < validLinks.length - 1 && <br />}
        </React.Fragment>
      ))}
    </div>
  );
};

export default AutomationFooter;
